import {
  GUEST_USER_ID_IDS,
  getEffectiveUserId,
} from "../../../utils/effectiveUserId";

/**
 * Optional fixed `user_id` for ticket mutation APIs (UpdateTicketDetail, UpdateTicketStatus, DeleteTicketById).
 * Set to a string when you need a literal id; leave null to use session rules below.
 *
 * When not logged in (no valid session), this resolves to {@link GUEST_USER_ID_IDS} from .env.
 */
export const HARDCODED_TICKET_USER_ID = null;

export function getUserIdForTicketMutation() {
  if (HARDCODED_TICKET_USER_ID != null && `${HARDCODED_TICKET_USER_ID}`.length > 0) {
    return `${HARDCODED_TICKET_USER_ID}`;
  }
  return getEffectiveUserId();
}
